import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';

import { 
  setDistrict,
  setRegion,
  setLocality,
  setHumidity,
  setSubject
} from '../../../slices/humidityZone/humidityZoneSlice';

import { selectorZone } from '../../../slices/humidityZone/humidityZoneSelectors';

import { CustomSelect, prepareSelectsData } from '../../UI/CustomSelect/CustomSelect'
import { Display } from '../../Display/Display'
import { Notice } from '../../Notice/Notice'
import './HumidityZone.css'


const humidityDisplayHalper = (humidityValue) => {
  const parcedHumidityVal = Array.isArray(humidityValue) ? humidityValue[0] : humidityValue;
  
  switch(parcedHumidityVal) {
    case 'влажная' : 
      return '1 — влажная'
    case 'нормальная' : 
      return '2 — нормальная'
    case 'сухая' : 
      return '3 — сухая'
    default : 
      return '—'
  }
}


export const HumidityZone = () => {
  const dispatch = useDispatch();

  const [district, region, locality, humidity] = useSelector(selectorZone);

  const humidityList = useSelector((state) => state.humidityZone.humidityZone);

  const [districtList, setDistrictList] = useState({});
  const [regionList, setRegionList] = useState();
  const [localityList, setLocalityList] = useState();

  useEffect(() => {
    const preparedDistrict = prepareSelectsData(Object.keys(humidityList));
    
    setDistrictList(preparedDistrict)
  }, [humidityList])
  
  useEffect(() => {
    const regionBySelectDistrict = humidityList[district?.value];
    const prapereRegion = prepareSelectsData(Object.keys(regionBySelectDistrict || {}));

    setRegionList(prapereRegion);
  }, [humidityList, district])


  useEffect(() => {
    const regionBySelectDistrict = humidityList[district?.value];
    const localityBySelectRegion = regionBySelectDistrict ? regionBySelectDistrict[region?.value] : {};
    const prapereLocality = prepareSelectsData(Object.keys(localityBySelectRegion || {}));

    setLocalityList(prapereLocality);
  }, [humidityList, district, region])

  useEffect(() => {
    const regionBySelectDistrict = humidityList[district?.value];
    const localityBySelectRegion = regionBySelectDistrict ? regionBySelectDistrict[region?.value] : {};
    const humidity = localityBySelectRegion ? localityBySelectRegion[locality?.value] : undefined;

    if (humidity) {
      dispatch(setHumidity(Object.keys(humidity)[0]));
      dispatch(setSubject(Object.values(humidity)[0]));
    }
  }, [humidityList, district, region, locality, dispatch])


  const changeHandler = (action, isReset=false) => {
    if (isReset) {
      dispatch(setRegion(undefined));
      dispatch(setLocality(undefined));
    }
    dispatch(action);
  }

  return (
    <div className='humidiate-zone'>

      <div className="humidiate-zone__select-wrapper">
        <div className="humidiate-zone__select">
          <CustomSelect 
            options={districtList}
            onChange={(choice)=>changeHandler(setDistrict(choice), true)}
            placeholder={'Округ'}
            value={district || ''}
          />
        </div>
        <div className="humidiate-zone__select">
          <CustomSelect 
            options={regionList}
            onChange={(choice)=>changeHandler(setRegion(choice), true)}
            placeholder={'Область / Республика'}
            value={region || ''}
          />
        </div>
        <div className="humidiate-zone__select">
          <CustomSelect 
            options={localityList}
            onChange={(choice)=>changeHandler(setLocality(choice))}
            placeholder={'Населенный пункт'}
            value={locality || ''}
          />
        </div>
      </div>

      <div className="humidiate-zone__display">
        <Display 
          text={'Зона влажности для вашего населённого пункта'} 
          displayParam={humidityDisplayHalper(humidity)}
        >
          <Notice>
            <div className="humidiate-zone__notice-wrapper">
              Зона влажности — один из параметров, который учитывается при расчёте утеплителя. 
              Это территория со схожими влажностными характеристиками.
              <div className="humidiate-zone__notice-info">
                Обозначается цифрами от 1 до 3
              </div>
              Чем выше цифра — тем суше зона.  
            </div>

            <div className="humidiate-zone__notice-wrapper--mobile">
                Зона влажности — один из параметров, который учитывается при расчёте утеплителя. 
                Это территория со схожими влажностными характеристиками.
                <div className="humidiate-zone__notice-info">
                  Обозначается цифрами от 1 до 3
                </div>
                Чем выше цифра — тем суше зона. 
            </div>
          </Notice>
        </Display>
      </div>
    </div>
  )
}
